export default __webpack_public_path__ + "static/media/icon-seventh-airplane.efc09302.svg";